import React, { Component, Fragment } from 'react'

import Button from '../../components/Button/'
import Error from '../../components/Error/'
import { Cross } from '../Icons'
import { Container, Popup, CloseButton, ButtonContainer, Title, Header, Inner } from './styles'
import { white, almostblack, black, lightgray, red } from '../../styles/colors'

class SubmitOCIOrderPopup extends Component {

  handleSubmit(e) {
    e.preventDefault()
    this.updateOrder(e.currentTarget)
  }

  updateOrder(currentTarget) {
    this.props.submitOrder({ variables: { data: { id: this.props.id, email: this.props.user.email, firstName: this.props.user.firstName, insertion: this.props.user.insertion ? this.props.user.insertion : '', lastName: this.props.user.lastName, contactCode: this.props.user.contactCode, ociPlatform: this.props.ociPlatform} } }).then((result) => {
      currentTarget.submit()
    }).catch((error) => {
      console.error(error)
    })
  }

  render() {
    const { title, confirm, deny, error, order, hookUrl, ociPlatform } = this.props
    console.log(this.props)
    if (error) {
      return <Error message={`Fout opgetreden bij het verzenden van uw bestelling met ID: ${this.props.id}`} />
    }

    const url = new URL(decodeURIComponent(hookUrl))
    const urlParams = new URLSearchParams(url.search)
    let orderPartIndex = 0

    return (
      <Container>
        <Popup>
          <Inner>
            <Header>
              <Title>{title}</Title>

              <CloseButton onClick={this.props.closePopup}>
                <Cross size="xlarge" />
              </CloseButton>
            </Header>
            <ButtonContainer>
              <form method="post" action={decodeURIComponent(hookUrl)} onSubmit={this.handleSubmit.bind(this)}>
                {urlParams.get('hash') && urlParams.get('supplier_id') ? (
                  <Fragment>
                    <input type="hidden" name="supplier_id" value={urlParams.get('supplier_id')} />
                    <input type="hidden" name="hash" value={urlParams.get('hash')} />
                  </Fragment>
                ) : null}
                {order.orderParts.map((orderPart, index) => {
                  // Calculate price
                  let price = 0
                  // Search for priceAgreements with the same product, sort by priority and take the last one
                  const priceAgreementsProduct = this.props.priceAgreements ? this.props.priceAgreements.filter(priceAgreement => priceAgreement.productCode === orderPart.product.productCode) : false
                  const priceAgreementSorted = priceAgreementsProduct.length > 0 ? priceAgreementsProduct.sort((a, b) => a.priority - b.priority)
                  .filter((item, index, array) => item.priority === array[0].priority) : false
                  const priceAgreement = priceAgreementSorted.length > 0 ? priceAgreementSorted[0] : false
                  const orderPartPrice = priceAgreement ? priceAgreement.percentage ? orderPart.product.price * ((100 - priceAgreement.percentage) / 100) : priceAgreement.price : orderPart.product.price
                  price = price + orderPartPrice
                  console.log(orderPart)
                  if (orderPart.amount > 0) {
                    orderPartIndex++
                    return (
                      <Fragment key={index}>
                        <input name={`NEW_ITEM-DESCRIPTION[${orderPartIndex}]`} value={orderPart.product.firstDescription} type="hidden" />
                        <input name={`NEW_ITEM-VENDORMAT[${orderPartIndex}]`} value={orderPart.product.productCode} type="hidden" />
                        <input name={`NEW_ITEM-QUANTITY[${orderPartIndex}]`} value={orderPart.amount} type="hidden" />
                        <input name={`NEW_ITEM-UNIT[${orderPartIndex}]`} value={orderPart.product.unit} type="hidden" />
                        <input name={ociPlatform === 'AFAS' ? `NEW_ITEM-CUST_FIELD1[${orderPartIndex}]` : `NEW_ITEM-VATPERCENTAGE[${orderPartIndex}]`} value={orderPart.product.btw} type="hidden" />
                        <input name={`NEW_ITEM-PRICE[${orderPartIndex}]`} value={price} type="hidden" />
                        {ociPlatform === 'AFAS' ? null : <input name={`NEW_ITEM-CUST_FIELD5[${orderPartIndex}]`} value={this.props.branch} type="hidden" />}
                        {ociPlatform === 'AFAS' ? null : <input name={`NEW_ITEM-CUST_FIELD6[${orderPartIndex}]`} value={this.props.id} type="hidden" />}
                      </Fragment>
                    )
                  } else {
                    return null
                  }
                })}
              <Button
                type="submit"
                background={red}
                color={white}
                border={red}
                radius="true"
                hover={almostblack}
                hoverColor={white}
              >
                {confirm}
              </Button>
              </form>

              <Button
                background={white}
                color={black}
                border={lightgray}
                radius="true"
                hover={almostblack}
                hoverColor={white}
                onSubmit={this.props.closePopup}
              >
                {deny}
              </Button>
            </ButtonContainer>
          </Inner>
        </Popup>
      </Container>
    )
  }
}

export default SubmitOCIOrderPopup



// WEBPACK FOOTER //
// ./src/components/SubmitOCIOrderPopup/index.js